// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x-Questions-questions {
  line-height: 1.3;
}
.x-Questions-questionsLabel {
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./modules/portal-core/components/fields/Questions.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAEA;EACE,iBAAA;AAAF","sourcesContent":[".questions {\n  line-height: 1.3;\n}\n\n.questionsLabel {\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"questions": `x-Questions-questions`,
	"questionsLabel": `x-Questions-questionsLabel`
};
export default ___CSS_LOADER_EXPORT___;
